module.exports = __webpack_public_path__ + "assets/img/6.f49cba58.png";